import { render, staticRenderFns } from "./MilestoneTemplate.vue?vue&type=template&id=7106e850&"
import script from "./MilestoneTemplate.vue?vue&type=script&lang=js&"
export * from "./MilestoneTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports